export const MODES = {
  HOME: 'HOME',
  IN_LOBBY: 'IN_LOBBY',
  IN_GAME: 'IN_GAME',
};
